import { render, staticRenderFns } from "./StartRisingStarModal.vue?vue&type=template&id=ded3663e&scoped=true"
import script from "./StartRisingStarModal.vue?vue&type=script&lang=js"
export * from "./StartRisingStarModal.vue?vue&type=script&lang=js"
import style0 from "./StartRisingStarModal.vue?vue&type=style&index=0&id=ded3663e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded3663e",
  null
  
)

export default component.exports